<template>
  <div class="addbidPlan">
    <div class="tabWrap">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="screenPanel">
            <el-form
              ref="ruleForm"
              :model="dateForm"
              label-width="150px"
              :inline="true"
              :rules="rules"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="项目名称" prop="projectId">
                    <el-select
                      v-model="dateForm.projectId"
                      placeholder="请选择"
                      clearable
                      filterable
                      @change="changeProject"
                    >
                      <el-option
                        v-for="item in projectIdList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="采购计划编号" prop="bidPlanCode">
                    <el-input
                      v-model="dateForm.bidPlanCode"
                      placeholder="编码格式：QDLQ-CG-项目名称首字母大写-三位数顺序序号"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购方式：" prop="bidPlanMethodKey">
                    <el-select
                      v-model="dateForm.bidPlanMethodKey"
                      filterable
                      default-first-option
                      placeholder="请选择"
                      @change="changeType"
                    >
                      <el-option
                        v-for="item in typeOption"
                        :key="item.label"
                        :label="item.value"
                        :value="item.label"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="采购计划事项" prop="bidPlanItem">
                    <el-input v-model="dateForm.bidPlanItem"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="项目类别" prop="projectType">
                    <el-input v-model="dateForm.projectType"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="预估金额" prop="estimatePrice">
                    <el-input v-model="dateForm.estimatePrice"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="是否已取得决策依据">
                    <el-select
                      v-model="dateForm.isDecisionBase"
                      placeholder="请选择"
                    >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目主要内容" prop="projectGeneral">
                    <el-input
                      type="textarea"
                      :rows="6"
                      maxlength="5000"
                      show-word-limit
                      placeholder="请输入内容"
                      v-model="dateForm.projectGeneral"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input
                      type="textarea"
                      :rows="6"
                      maxlength="5000"
                      show-word-limit
                      placeholder="请输入内容"
                      v-model="dateForm.remark"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="附件"
          name="fourth"
          style="text-align: left"
          class="firstTab"
        >
          <upLoadFileDialog
            :itemVOs="dateForm.attachmentList"
            @saveUpdateFile="saveUpdateFile"
          ></upLoadFileDialog>
        </el-tab-pane>
        <el-tab-pane
          label="审批流程"
          name="fivth"
          style="text-align: left; width: 90%; margin-top: 20px"
        >
          <addApproveLine
            :addoredit="editFlag"
            :itemId="bidPlanId || 0"
            @saveApproveLine="saveApproveLine"
            @saveApproveType="saveApproveType"
            :approveType="approveType"
            :approveClass="approveClass"
            :subApproveType="dateForm.approveTemplateType"
            :subApproveName="dateForm.approveTemplateName || ''"
          ></addApproveLine>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottomBtn">
      <el-button type="primary" @click="savebidplanInfo(0)">暂 存</el-button>
      <el-button type="primary" @click="savebidplanInfo(2)">提 交</el-button>
      <el-button type="info" @click="close">取 消</el-button>
    </div>
    <!--选择部门弹窗 -->
    <select-dialog
      :visible="selectDialogVisible"
      @close="selectDialogClose"
      title="选择"
      v-bind="selectDialogOptions"
    />
  </div>
</template>

<script>
import {
  savebidPlan, //新增一条采购计划
  updatebidPlan, //更新一条采购计划
  getbidPlandetail, //获取一条采购计划信息
  getBidTypeDic, //获取一级数据字典接口
  getBidPlanNo, //查询采购计划编号序号
} from "@/services/bidServices";
import { getAllProjectPassListService } from "@/services/engineering";
import {
  saveApproveFun,
  updateApproveFun,
} from "@/page/approveComponents/approve";
import addApproveLine from "@/page/approveComponents/NewApproveLine"; //新增审批流程
import upLoadFileDialog from "@/components/upLoadFileDialog"; //上传附件
import SelectDialog from "@/components/SelectDialog";

import pinyin from "@/utils/pinyin";

export default {
  name: "addbidPlan",
  components: {
    SelectDialog, //选择部门弹窗
    upLoadFileDialog, //上传附件
    addApproveLine,
  },
  data() {
    return {
      activeName: "first", //活动tab页
      approveType: "bidmanager", //审批流类型
      approveClass: "BID_PLAN",
      flag: false, //是否保存过审批流
      editFlag: false, //false：新建 true：编辑
      deptIdList: [],
      projectIdList: [], //所属项目下拉框
      typeOption: [],
      bidPlanId: "", //存储id
      selectDialogVisible: false,
      dateForm: {
        // id: 0,
        bidPlanCode: "", //采购计划编号
        projectId: "", //项目名称
        projectGeneral: "", //项目概括
        bidPlanItem: "", //采购计划事项
        attachmentList: [], //采购计划附件
        projectType: "", //项目类别
        bidPlanMethodKey: "", //采购方式字典key
        bidPlanMethodValue: "", //
        isDecisionBase: "0",
        estimatePrice: null, //预估金额
        status: "", //是否暂存标识 0：暂存，2：提交
        remark: "", //备注
        approveTemplateType: "bidplan",
        approveTemplateName: "采购计划",
      },
      approveParams: {
        approveProcessDtoList: [], //审批流列表
        approveStatusEnum: "UNDERAPPLY", //初始审批状态，目前只支持READY和UNDERAPPLY,可用值:READY,RECALL,UNDERAPLLY,PASS,REJECT,SHOW_SAVE,SHOW_CREATE,SHOW_SUBMIT
        itemId: 0, //审批对象ID
        itemName: "", //审批对象描述
        projectId: 0, //项目ID
      },
      selectDialogOptions: {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "reportPerson",
        canSelectAll: true,
      },
      rules: {
        bidPlanMethodKey: [
          { required: true, message: "请选择采购方式", trigger: "change" },
        ],
        bidPlanCode: [
          { required: true, message: "请填写采购计划编码", trigger: "blur" },
          {
            pattern: /^QDLQ-CG-[A-Z\d]+-[\d]{3}$/,
            message: "格式：QDLQ-CG-项目名称首字母大写-三位数顺序序号",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],
        projectId: [
          { required: true, message: "请选择项目名称", trigger: "change" },
          // {
          //   min: 1,
          //   max: 60,
          //   message: "长度在 1 到 60 个字符",
          //   trigger: "blur",
          // },
        ],

        bidPlanItem: [
          { required: true, message: "请填写采购计划事项", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],

        projectGeneral: [
          { required: true, message: "请填写项目主要内容", trigger: "blur" },
          {
            min: 1,
            max: 5000,
            message: "长度在 1 到 5000 个字符",
            trigger: "blur",
          },
        ],
        estimatePrice: [
          { required: true, message: "请填写预估金额", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
          // {
          //   pattern: /^[\u4e00-\u9fa50-9.-]+$/,
          //   message: "只能输入-.数字以及汉字",
          //   trigger: "blur",
          // },
        ],
        projectType: [
          { required: true, message: "请填写项目类别", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.dateForm.applyUserName = sessionStorage.getItem("name");
    // this.dateForm.applyDeptId = sessionStorage.getItem("deptId");
    // this.dateForm.applyUserId = sessionStorage.getItem("currentUserId");
    this.getProject();
    this.getbidPlanType();
  },
  mounted() {
    // let ch = document.documentElement.clientHeight - 60;
    // try {
    //   document.getElementsByClassName("addbidPlan")[0].style.height = ch + "px";
    // } catch (error) {
    //   console.log("-- tableHeight error\n", error);
    // }
    // window.onresize = () => {
    //   return (() => {
    //     let ch1 = document.documentElement.clientHeight - 60;
    //     document.getElementsByClassName("addbidPlan")[0].style.height =
    //       ch1 + "px";
    //   })();
    // };
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.dateForm.id = this.tabRouteParam?.id ?? 0;
      if (this.dateForm.id) {
        this.editFlag = true;
        //编辑 获取详情
        this.bidPlanId = this.tabRouteParam.id;
        this.getDetail(this.bidPlanId);
      }
    },
    //tab页切换
    handleTabClick(tab, event) {
      switch (this.activeName) {
        case "seven":
          break;
        case "second2":
          // this.getDefaultDetailsList();
          break;
        default:
          // this.Contractform.tabIndex = "0";
          break;
      }
    },
    //获取采购计划类型下拉框数据
    getbidPlanType() {
      getBidTypeDic().then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.typeOption = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    getProject() {
      getAllProjectPassListService()
        .then((res) => {
          if (res.code == "10000000") {
            this.projectIdList = res.data || [];
          }
        })
        .catch(() => {});
    },

    //切换项目名称
    changeProject() {
      let index = this.projectIdList.findIndex(
        (item) => item.id === this.dateForm.projectId
      );
      if (index !== -1) {
        this.dateForm.projectName = this.projectIdList[index].name;
        this.dateForm.projectDeptName = this.projectIdList[index].deptName;
        this.dateForm.projectDeptId = this.projectIdList[index].deptId;
      }
      let str = pinyin.simplePinYin(this.dateForm.projectName);
      // this.dateForm.bidPlanCode = "QDLQ-CG-" + str + "-00";
      let code = "QDLQ-CG-" + str;
      this.getPlanNo(code);
    },

    /* 打开新增采购计划弹窗 */
    addBidPlan() {
      // if (null == row.productDeptLevel) {
      //   this.$alert("请先完成生产部门评分", "提示", {
      //     confirmButtonText: "确定",
      //   });
      //   return;
      // }
      this.$refs.addPlanDialog.showDialog(); //this.row.id);
    },

    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    // 提交基本信息
    savebidplanInfo(val) {
      this.$refs["ruleForm"].validate((valid) => {
        //val=0 暂存 2：提交
        if (valid) {
          this.dateForm.status = val;
          if (val == 0) {
            this.tempSaveContent();
            return;
          }
          if (this.approveParams.approveProcessDtoList.length < 1) {
            this.$alert(" 未选择审批人员", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          for (
            let i = 0;
            i < this.approveParams.approveProcessDtoList.length;
            i++
          ) {
            delete this.approveParams.approveProcessDtoList[i].type;
            if (
              this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
              null == this.approveParams.approveProcessDtoList[i].approveUserId
            ) {
              // this.$alert(
              //   this.approveParams.approveProcessDtoList[i].jobName +
              //     " 节点未选择审批人员",
              //   "提示",
              //   {
              //     confirmButtonText: "确定",
              //   }
              // );
              this.$alert("未选择审批人员", "提示", {
                confirmButtonText: "确定",
              });
              return;
            }
          }
          let msg = "您确定提交吗, 是否继续?";
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info",
          })
            .then(() => {
              this.saveContent();
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    saveContent() {
      // let data = { ...this.dateForm };
      let param = {};
      param = { ...this.dateForm };

      if (!this.editFlag) {
        //新增采购计划
        savebidPlan(param)
          .then((res) => {
            if (res.code == 10000000) {
              //保存审批流
              this.saveApproveFun(res.data);
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      } else {
        //更新采购计划
        param.id = this.bidPlanId;
        updatebidPlan(param)
          .then((res) => {
            if (res.code == 10000000) {
              //保存审批流
              console.log();
              this.saveApproveFun(this.bidPlanId);
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },

    tempSaveContent() {
      // let data = { ...this.dateForm };
      let param = {};
      if (
        this.dateForm.approveTemplateType &&
        this.approveParams.approveProcessDtoList.length > 0
      ) {
        //撤回状态的合同暂存的时候保存审批流
        if (this.approveParams.approveProcessDtoList.length < 1) {
          this.$alert(" 未选择审批人员", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
        for (
          let i = 0;
          i < this.approveParams.approveProcessDtoList.length;
          i++
        ) {
          delete this.approveParams.approveProcessDtoList[i].type;
          if (
            this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
            null == this.approveParams.approveProcessDtoList[i].approveUserId
          ) {
            this.$alert("未选择审批人员", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        }
      }
      param = { ...this.dateForm };

      if (!this.editFlag) {
        //新增采购计划
        savebidPlan(param)
          .then(async (res) => {
            if (res.code == 10000000) {
              //保存审批流
              if (
                this.dateForm.approveTemplateType &&
                this.approveParams.approveProcessDtoList.length > 0
              ) {
                await this.saveTempApproveFun(res.data);
              } else {
                this.$message.success("暂存成功");
              }

              this.bus.$emit("tabClose", "bidPlanAdd");
              this.bus.$emit("navMenuChange", {
                routeId: "bidPlan",
              });

              this.clearDialogForm();
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      } else {
        //更新采购计划
        param.id = this.bidPlanId;
        updatebidPlan(param)
          .then(async (res) => {
            if (res.code == 10000000) {
              // this.$message.success("暂存成功");
              //保存审批流
              if (
                this.dateForm.approveTemplateType &&
                this.approveParams.approveProcessDtoList.length > 0
              ) {
                await this.saveTempApproveFun(this.bidPlanId);
              } else {
                this.$message.success("暂存成功");
              }

              this.bus.$emit("tabClose", "bidPlanEdit");
              this.bus.$emit("navMenuChange", {
                routeId: "bidPlan",
              });
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },

    //创建审批流函数
    async saveApproveFun(id) {
      this.approveParams.itemId = id;
      this.approveParams.projectId = this.dateForm.projectId ?? 0;
      this.approveParams.approveStatusEnum = "UNDERAPLLY"; //只是先保存，传READY；若审批流直接开始，传UNDERAPLLY
      this.approveParams.approveClass = "BID_PLAN";
      let subType = "采购计划";
      this.approveParams.itemName = `${this.dateForm.applyUserName}关于项目 ${this.dateForm.projectName} 采购计划编号为 ${this.dateForm.bidPlanCode} 的审批类型为 ${subType}申请`;
      let apiName = this.flag ? updateApproveFun : saveApproveFun;
      let res = await apiName(this.approveParams);
      if (res.code == 10000000) {
        if (!this.editFlag) {
          this.$message.success("保存成功");
          this.bus.$emit("tabClose", "bidPlanAdd");
          this.bus.$emit("navMenuChange", {
            routeId: "bidPlan",
          });
          this.clearDialogForm();
        } else {
          this.$message.success("提交成功");
          this.bus.$emit("tabClose", "bidPlanEdit");
          this.bus.$emit("navMenuChange", {
            routeId: "bidPlan",
          });
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    //暂存保存审批流
    async saveTempApproveFun(id) {
      for (
        let i = 0;
        i < this.approveParams.approveProcessDtoList.length;
        i++
      ) {
        delete this.approveParams.approveProcessDtoList[i].type;
        if (
          this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
          null == this.approveParams.approveProcessDtoList[i].approveUserId
        ) {
          this.$alert("未选择审批人员", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
      }
      this.approveParams.itemId = id;
      this.approveParams.projectId = this.dateForm.projectId ?? 0;
      this.approveParams.approveStatusEnum = "READY"; //只是先保存，传READY；若审批流直接开始，传UNDERAPLLY
      this.approveParams.approveClass = "BID_PLAN";
      let subType = "采购计划";
      this.approveParams.itemName = `${this.dateForm.applyUserName}关于项目 ${this.dateForm.projectName} 采购计划编号为 ${this.dateForm.bidPlanCode} 的 ${subType}申请`;
      let res = await saveApproveFun(this.approveParams);
      if (res.code == 10000000) {
        this.$message.success("暂存成功");
      } else {
        this.$message.error(res.msg);
      }
    },
    clearDialogForm() {
      this.dateForm = {
        id: 0,
        bidPlanCode: "", //采购计划编号
        projectId: "", //项目名称
        projectGeneral: "", //项目概括
        deptId: "", //提报部门
        attachmentList: [], //采购计划附件
        status: "", //是否暂存标识
      };
    },
    //切换类型
    changeType() {
      let index = this.typeOption.findIndex(
        (item) => item.label === this.dateForm.bidPlanMethodKey
      );
      if (index !== -1) {
        this.dateForm.bidPlanMethodKey = this.typeOption[index].label;
        this.dateForm.bidPlanMethodValue = this.typeOption[index].value;
      }
    },
    close() {
      let that = this;
      if (!this.editFlag) {
        this.bus.$emit("tabClose", "bidPlanAdd");
      } else {
        this.bus.$emit("tabClose", "bidPlanEdit");
      }
      this.bus.$emit("navMenuChange", {
        routeId: "bidPlan",
      });

      this.clearDialogForm();
    },
    //获取一条信息
    getDetail(id) {
      let param = {};
      param.bidPlanId = id;
      getbidPlandetail(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.dateForm = { ...this.dateForm, ...res.data };
            this.dateForm.isDecisionBase =
              this.dateForm.isDecisionBase.toString();
            this.dateForm.attachmentList = res.data.attachmentList ?? [];
            // this.dateForm.projectId = this.dateForm.projectId.toString();
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    //获取招标计划序号
    getPlanNo(prePlanNo) {
      let param = {};
      param.code = prePlanNo;
      getBidPlanNo(param)
        .then((res) => {
          if (res.code == 10000000) {
            let num=res.data
            this.dateForm.bidPlanCode = prePlanNo +'-'+String(num).padStart(3, '0');
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    closeDialog() {
      this.applyUserDiaVisible = false;
    },

    //存储附件
    saveUpdateFile(selectItems) {
      this.dateForm.attachmentList = selectItems;
    },
    //存储审批流模板类型
    saveApproveType(item) {
      this.dateForm.approveTemplateType = item.label;
      this.dateForm.approveTemplateName = item.value;
    },
    //存储审批流
    saveApproveLine(selectItems, flag = false) {
      this.flag = flag;
      this.approveParams.approveProcessDtoList = selectItems;
    },
    selectAttendDepart() {
      // 选择参会部门
      this.selectDialogOptions = {
        departOn: true,
        groupOn: false,
        canSelectDepart: true,
        canSelectUser: false,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "attendDepart",
      };
      this.selectDialogVisible = true;
    },
    selectDialogClose(data) {
      this.selectDialogVisible = false;
      const { dataKey } = data;
      switch (dataKey) {
        case "attendDepart": // 参会部门
          this.dateForm.projectDeptName = data.departList[0].name;
          this.dateForm.projectDeptId = data.departList[0].deptId;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.addbidPlan {
  background-color: white;
  height: 100%;
  overflow: hidden;

  .tabWrap {
    height: calc(100% - 60px);
    // /deep/.el-tabs__item.is-top.is-active {
    //   background-color: #ffffff;
    // }

    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 40px);
        padding: 0 20px;
        // margin-top: 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }

        .el-form-item__content {
          width: calc(100% - 150px);

          .el-input {
            width: 100%;
          }
        }
      }
    }
    .Contractfile {
      height: 44px;
      // padding-left: 24px;
      margin-bottom: 24px;
      box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
      border-radius: 2px 2px 0px 0px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 44px;
      text-align: left;
    }
  }

  .bottomBtn {
    // border-top: 1px solid #e6e6e6;
    width: 60%;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

/deep/ .el-cascader .el-input__inner {
  &::placeholder {
    color: #606266;
  }

  &::-webkit-input-placeholder {
    /* WebKit browsers 适配谷歌 */
    color: #606266;
  }
}

/*.el-container {*/
/*    width: 100%;*/
/*    overflow: hidden;*/
/*}*/

.approve-rule {
  color: red;
  /* text-align: right; */
  position: absolute;
  right: 30px;
  top: 20px;
  height: 40px;
  display: flex;
  align-items: center;
  z-index: 1;
}

/deep/ .el-header {
  position: relative;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}

/deep/ .el-tabs__header {
  padding-right: 0px !important;
}

.screenPanel {
  text-align: left;
  height: auto;
}

.operatePanel {
  text-align: left;
  margin: 20px 60px;
}

.el-select {
  width: 100%;
}
.el-cascader {
  width: 100%;
}
.btnList {
  text-align: center;
  margin-top: 20px;
}

.el-form-item {
  margin-bottom: 14px;
}

.time-box {
  //  display: flex;
  // height: 180px;
  overflow-y: auto;
  flex: 1;

  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
  }
}

.left {
  width: 320px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
}

.right {
  height: 32px;
  line-height: 32px;
  width: 60px;
  text-align: center;
  cursor: pointer;
}

.add {
  background-color: #00cccc;
  border-radius: 2px;
  color: #ecf5ff;
}

.el-select {
  margin-right: 10px;
}

/deep/ .el-date-editor--time {
  width: 130px;
}

/deep/ .el-container .el-main {
  height: auto;
}
.firstTab {
  width: 72%;
  margin-top: 20px;
}
.firstTab1 {
  width: 100%;
  margin-top: 20px;
}
@media only screen and(max-width:1610px) {
  .firstTab {
    width: 90%;
    margin-top: 20px;
  }
  .firstTab1 {
    width: 100%;
    margin-top: 20px;
  }
}
</style>

<style scoped>
.hidden >>> .el-upload--picture-card {
  display: none;
}
</style>
